import { Builder } from "@builder.io/react";
import { Accordion1, Faq1 } from "@/components/Accordion";
import { registerMenuGroups, commonInputs} from "./helper";

const accordionGroups = [
  {
    name: "Accordion Components",
    items: [  
      { name: "Faq 1" },
      { name: "Accordion 1" },
    ]
  },
];

export const registerAccordionComponents = () => {
  registerMenuGroups(accordionGroups);  

  // Faq Components
  Builder.registerComponent(Faq1, {
    name: "Faq 1",
    friendlyName: "Faq 1",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
      }),
      {
        name: "canSearch",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "faqSections",
        type: "list",
        defaultValue: [
          {
            title: "Section Title 1",
            faqItem: [
              {
                question: "Question 1",
                answer: "Answer 1",
              },
              {
                question: "Question 2",
                answer: "Answer 2",
              },
              {
                question: "Question 3",
                answer: "Answer 3",
              },
            ],
          },
          {
            title: "Section Title 2",
            faqItem: [
              {
                question: "Question 4",
                answer: "Answer 4",
              },
              {
                question: "Question 5",
                answer: "Answer 5",
              },
              {
                question: "Question 6",
                answer: "Answer 6",
              },
            ],
          },
        ],
        subFields: [
          {
            name: "title",
            type: "text",
            defaultValue: "Section Title",
          },
          {
            name: "faqItem",
            type: "list",
            subFields: [
              {
                name: "question",
                type: "text",
              },
              {
                name: "answer",
                type: "richText",
              },
            ],
          },
        ],
      },
    ],
  });

  Builder.registerComponent(Accordion1, {
    name: "Accordion 1",
    friendlyName: "Accordion 1",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
      }),
      {
        name: "accordionItem",
        type: "list",
        defaultValue: [
          {
            title: "Accordion Item 1",
            content: "Accordion Item 1",
          },
          {
            title: "Accordion Item 2",
            content: "Accordion Item 2",
          },
        ],
        subFields: [
          {
            name: "title",
            type: "text",
          },
          {
            name: "content",
            type: "richText",
          },
        ],
      },
    ],
  });
};
